import AlarmOutlinedIcon from "@mui/icons-material/AlarmOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import SupportAgentOutlinedIcon from "@mui/icons-material/SupportAgentOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";
import type { ComponentType } from "react";

/**
 * The six things a new member is told about Protocol 30.5.
 *
 * Pure data, like `shell/navigation.ts` and `settings/settings-nav.ts`: the labels are
 * i18n key *fragments* resolved by the screen, and the icons are the ones the member
 * will meet again in the tab bar and the profile menu — orientation works better when
 * the picture on the welcome screen is the same picture as the destination.
 *
 * Order is the numbering. `01 / SCIENCE` is index 0.
 */
export interface WelcomeStep {
  /** Key fragment under `welcome.steps.*`, and the suffix of the step's test id. */
  key: "science" | "categories" | "chat" | "support" | "events" | "routine";
  icon: ComponentType<SvgIconProps>;
  /** Support is the one entry that ends in an address rather than a full stop. */
  showsSupportEmail?: boolean;
}

export const WELCOME_STEPS: WelcomeStep[] = [
  { key: "science", icon: ScienceOutlinedIcon },
  { key: "categories", icon: FilterListOutlinedIcon },
  { key: "chat", icon: QuestionAnswerOutlinedIcon },
  { key: "support", icon: SupportAgentOutlinedIcon, showsSupportEmail: true },
  { key: "events", icon: CalendarMonthOutlinedIcon },
  { key: "routine", icon: AlarmOutlinedIcon },
];

/** `01`, `02`, … — the numeral printed above each label. */
export function stepNumber(index: number): string {
  return String(index + 1).padStart(2, "0");
}
